import CurbsideSVG from "@design-system/ui-icons/vanilla/Curbside"
import { createIcon } from "../createIcon"

export const CurbsideIcon = createIcon(CurbsideSVG)
